import React from "react";

export default function Banner() {
  return (
    <div className="hero">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Content */}
          <div className="col-lg-8">
            <div className="hero-content">
              {/* Title */}
              <div className="section-title">
                <h1
                  className="text-anime-style-3"
                  style={{ perspective: "400px" }}
                >
                 AI Powered Digital, IT & Technology Solutions Company
                </h1>
              </div>

              {/* Description */}
              <div className="hero-body">
                <p
                  className="wow fadeInUp"
                  data-wow-delay="0.5s"
                  style={{
                    visibility: "visible",
                    animationDelay: "0.5s",
                    animationName: "fadeInUp",
                  }}
                >
                  Web development and digital marketing are closely intertwined
                  fields that drive the success of modern businesses online.
                  Web development focuses on creating functional, user-friendly,
                  and visually appealing websites across devices.
                </p>
              </div>

              {/* Button */}
              <div className="hero-footer">
                <a
                  href="/contact-us"
                  className="btn-default wow fadeInUp"
                  data-wow-delay="0.75s"
                  style={{
                    visibility: "visible",
                    animationDelay: "0.75s",
                    animationName: "fadeInUp",
                  }}
                >
                  Free Consultation
                </a>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="col-lg-4">
            <div className="hero-video-image">
              <div className="hero-image">
                <figure
                  className="image-anime reveal"
                  style={{
                    transform: "translate(0px, 0px)",
                    opacity: 1,
                    visibility: "inherit",
                  }}
                >
                  <img
                    src="./assets/images/hero-img.jpg"
                    alt="Hero"
                    style={{ transform: "translate(0px, 0px)" }}
                  />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
